var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCombustible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #1a1b35;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M418.35,590.92a35.43,35.43,0,0,1-35.44-35.48c0-19.63,35.44-81.73,35.44-81.73s35.44,62.14,35.44,81.73A35.45,35.45,0,0,1,418.35,590.92Zm-26.7-144.66H351V662.91H280.53v33.32h41v30.64H2.5V696.23h41V353.16h237V632.23h39.77V431l.18-15.38h86.14l23.8,30.57L406.27,465ZM228,406.27H96v98.51H228ZM665.09,476a101.38,101.38,0,0,1,10.72,17.09,97.69,97.69,0,0,1,6.73,19l219-128Zm-102.62.69A71.36,71.36,0,1,0,658.79,507,71.34,71.34,0,0,0,562.47,476.72ZM632.24,98.21H576.3V245.13h55.94ZM576.33,981.79h55.94V834.84H576.33ZM930.58,512v56H1077.5V512ZM788.79,287.19,808.57,307,912.45,203.09l-19.81-19.78Zm0,505.61L892.67,896.68l19.78-19.78L808.61,773ZM447.16,917.39H519V892.1h-71.8V860.89h77.43v-26H416.45V981.79H528V955.67H447.16Zm3.4-672.26V183h64.36V157.73H450.56V124.3h73.89V98.21H419.92V245.13h30.64Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCombustible);
export default __webpack_public_path__ + "static/media/combustible.f9c3e744e4adbf1f01164a5776616db6.svg";
export { ForwardRef as ReactComponent };